export type BlockOrigin = "AI" | "USER";
export type ParagraphStyle = "BODY" | "HEADING_1" | "HEADING_2" | "HEADING_3" | "BULLET" | "NUMBERED" | "QUOTE";

export type BlockFile = {
  id: string;
  originalName: string;
  contentType: string;
  sizeBytes: number;
  sha256: string;
};

export type TextStyle = {
  from: number;
  to: number;
  bold?: boolean;
  italic?: boolean;
  underline?: boolean;
  link?: string;
  code?: boolean;
  strike?: boolean;
  color?: string;
};

type BlockBase = {
  id: string;
  origin?: BlockOrigin;
  /** Plain text stays searchable; keys are "text" or table "row:column" (header is row 0). */
  formatting?: Record<string, TextStyle[]>;
};

export type ParagraphBlock = BlockBase & {
  type: "PARAGRAPH";
  text: string;
  style?: ParagraphStyle;
};

export type TableBlock = BlockBase & {
  type: "TABLE";
  columns: string[];
  rows: string[][];
  caption?: string;
};

export type ImageBlock = BlockBase & {
  type: "IMAGE";
  file: BlockFile;
  caption?: string;
  altText?: string;
  width?: number;
  height?: number;
};

export type FileBlock = BlockBase & {
  type: "FILE";
  file: BlockFile;
  caption?: string;
};

export type DocumentBlock = ParagraphBlock | TableBlock | ImageBlock | FileBlock;

export function blockId() {
  return globalThis.crypto?.randomUUID?.() || `block-${Date.now()}-${Math.random().toString(36).slice(2)}`;
}

export function paragraph(text = "", origin: BlockOrigin = "USER"): ParagraphBlock {
  return { id: blockId(), type: "PARAGRAPH", text, origin };
}

export function tableBlock(): TableBlock {
  return { id: blockId(), type: "TABLE", columns: ["항목", "측정값", "판정"], rows: [["", "", ""]], origin: "USER" };
}
